const API_BASE = import.meta.env.VITE_API_URL;

// Helper to check if response is 401 and handle logout
const handle401 = async (response) => {
  if (response.status === 401) {
    // Import dynamically to avoid circular dependency
    const { default: useAuthStore } = await import("../../store/authStore");
    useAuthStore.getState().logout();
    // Redirect to login
    window.location.href = "/#/login";
  }
};

export const getTeams = async (organizationId, token) => {
  try {
    const response = await fetch(
      `${API_BASE}/api/teams?organizationId=${organizationId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      await handle401(response);
      throw new Error("Failed to fetch teams");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching teams:", error);
    throw error;
  }
};

export const getTeamById = async (teamId, token) => {
  try {
    const response = await fetch(`${API_BASE}/api/teams/${teamId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      await handle401(response);
      throw new Error("Failed to fetch team");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching team:", error);
    throw error;
  }
};

export const createTeam = async (teamData, token) => {
  try {
    const response = await fetch(`${API_BASE}/api/teams`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(teamData),
    });

    if (!response.ok) {
      await handle401(response);
      throw new Error("Failed to create team");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating team:", error);
    throw error;
  }
};

export const updateTeam = async (teamId, teamData, token) => {
  try {
    const response = await fetch(`${API_BASE}/api/teams/${teamId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(teamData),
    });

    if (!response.ok) {
      await handle401(response);
      throw new Error("Failed to update team");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating team:", error);
    throw error;
  }
};

export const deleteTeam = async (teamId, token) => {
  try {
    const response = await fetch(`${API_BASE}/api/teams/${teamId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      await handle401(response);
      throw new Error("Failed to delete team");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting team:", error);
    throw error;
  }
};
